'use strict';

module.exports = function () {
    $(document).ready(function () {
        const $body = $('body');
        const $header = $('#pageHeader');

        if (!$header.length) return;

        const scrollOffset = $header.data('scroll-offset');
        const stickyMode = $header.data('sticky-mode');
        const isStickyHeader = stickyMode === 'sticky' || stickyMode === 'stickyOverlay';
        const isStickyOverlay = stickyMode === 'stickyOverlay';
        const isTransparentHeader = $body.hasClass('m-transparent_header') || $header.hasClass('m-transparent_header');
        const hasScrollOffset = scrollOffset !== undefined && scrollOffset !== null && scrollOffset !== '';

        if (!isTransparentHeader && (!isStickyHeader || !hasScrollOffset)) return;

        let headerHeight = 0;
        let lastScrollTop = 0;
        let lastWindowWidth = window.innerWidth;

        const setHeaderHeightVar = (height) => {
            const value = height + 'px';

            $header.css('--header-height', value);
            $body.css('--header-height', value);
        };

        const isPastOffset = () => {
            if (!hasScrollOffset) return $(window).scrollTop() > 0;

            return $(window).scrollTop() > scrollOffset;
        };

        const measureFullHeaderHeight = () => {
            const hadScrollStart = $header.hasClass('scroll-start');
            const $headerContent = $header.find('.header-content');

            if (hadScrollStart) {
                $headerContent.css('transition', 'none');
                $header.removeClass('scroll-start');
            }

            const height = $header.outerHeight();

            if (hadScrollStart) {
                $header.addClass('scroll-start');

                window.requestAnimationFrame(function () {
                    $headerContent.css('transition', '');
                });
            }

            return height;
        };

        const syncHeaderHeight = () => {
            headerHeight = measureFullHeaderHeight();
            setHeaderHeightVar(headerHeight);

            if (!isStickyHeader) {
                $body.css('padding-top', 0);

                return;
            }

            if (isTransparentHeader) {
                $body.css('padding-top', 0);
            } else {
                $body.css('padding-top', headerHeight);
            }
        };

        const updateScrollStartState = () => {
            if (!isStickyHeader) return;

            const wasScrollStart = $header.hasClass('scroll-start');
            const nowScrollStart = isPastOffset();

            $header.toggleClass('scroll-start', nowScrollStart);

            if (wasScrollStart && !nowScrollStart) syncHeaderHeight();
        };

        const hideMinicartPopover = () => {
            $header.find('.minicart .popover').removeClass('show');
        };

        const handleOverlayScroll = () => {
            const currentScrollTop = $(window).scrollTop();
            const scrollDifference = currentScrollTop - lastScrollTop;

            updateScrollStartState();

            if (Math.abs(scrollDifference) < scrollOffset) {
                return;
            }

            const isScrollingUp = scrollDifference < 0;

            $header.toggleClass('scroll-up', isScrollingUp);

            if (!isScrollingUp) {
                hideMinicartPopover();
            }

            lastScrollTop = currentScrollTop;
        };

        const handleStickyScroll = () => {
            updateScrollStartState();
        };

        const handleResize = () => {
            if (window.innerWidth === lastWindowWidth) {
                return;
            }

            lastWindowWidth = window.innerWidth;
            syncHeaderHeight();
        };

        const handlePageShow = () => {
            updateScrollStartState();
            syncHeaderHeight();
        };

        if (!isStickyHeader) {
            syncHeaderHeight();
            $body.on('promoBannerClosed promoBannerUpdated', syncHeaderHeight);
            $(window).on('resize', handleResize);
            $(window).on('pageshow', handlePageShow);

            return;
        }

        $header.addClass('sticky');

        if (isStickyOverlay) {
            updateScrollStartState();
            $(window).on('scroll', handleOverlayScroll);
        } else {
            $header.addClass('scroll-up');
            updateScrollStartState();
            $(window).on('scroll', handleStickyScroll);
        }

        syncHeaderHeight();

        $body.on('promoBannerClosed promoBannerUpdated', syncHeaderHeight);
        $(window).on('resize', handleResize);
        $(window).on('pageshow', handlePageShow);
    });
};
